export const LANGS = ["es", "en", "ca", "fr", "de", "it", "zh", "ja"];
const EXTRA = ["ca", "fr", "de", "it", "zh", "ja"];

// Base localized paths for es + en. Extra languages are derived as /{lang}{en-path-without-/en}.
const BASE = {
  home: { es: "/", en: "/en" },
  rooms: { es: "/habitaciones", en: "/en/rooms" },
  roomDetail: { es: "/habitaciones/:slug", en: "/en/rooms/:slug" },
  services: { es: "/servicios", en: "/en/services" },
  corporate: { es: "/empresas", en: "/en/business" },
  meetingRooms: { es: "/empresas/salas-reuniones", en: "/en/business/meeting-rooms" },
  meetingRoomDetail: { es: "/empresas/salas-reuniones/:slug", en: "/en/business/meeting-rooms/:slug" },
  events: { es: "/eventos", en: "/en/events" },
  weddings: { es: "/eventos/bodas", en: "/en/events/weddings" },
  celebrations: { es: "/eventos/celebraciones", en: "/en/events/celebrations" },
  groups: { es: "/eventos/grupos", en: "/en/events/groups" },
  restaurant: { es: "/restaurante", en: "/en/restaurant" },
  location: { es: "/ubicacion", en: "/en/location" },
  biosphere: { es: "/sostenibilidad", en: "/en/sustainability" },
  survey: { es: "/sostenibilidad/encuesta", en: "/en/sustainability/survey" },
  gallery: { es: "/galeria", en: "/en/gallery" },
  blog: { es: "/blog", en: "/en/blog" },
  blogPost: { es: "/blog/:slug", en: "/en/blog/:slug" },
  contact: { es: "/contacto", en: "/en/contact" },
  legal: { es: "/aviso-legal", en: "/en/legal-notice" },
  privacy: { es: "/privacidad", en: "/en/privacy" },
  cookies: { es: "/cookies", en: "/en/cookies" },
  nearSeat: { es: "/hotel-cerca-de-seat-martorell", en: "/en/hotel-near-seat-martorell" },
  nearMontserrat: { es: "/hotel-cerca-de-montserrat", en: "/en/hotel-near-montserrat" },
  parkingBarcelona: { es: "/hotel-con-parking-cerca-de-barcelona", en: "/en/hotel-with-parking-near-barcelona" },
  weddingsBaix: { es: "/hotel-bodas-baix-llobregat", en: "/en/wedding-hotel-baix-llobregat" },
};

export const ROUTES = Object.fromEntries(
  Object.entries(BASE).map(([key, paths]) => {
    const rest = paths.en.replace(/^\/en/, ""); // "" for home, "/rooms", "/rooms/:slug"...
    const full = { es: paths.es, en: paths.en };
    for (const l of EXTRA) full[l] = `/${l}${rest}`;
    return [key, full];
  })
);

export function langFromPath(pathname) {
  const seg = pathname.split("/")[1];
  return seg === "en" || EXTRA.includes(seg) ? seg : "es";
}

export function buildPath(key, lang, params = {}) {
  let p = (ROUTES[key] && ROUTES[key][lang]) || ROUTES[key].es;
  Object.entries(params).forEach(([k, v]) => {
    p = p.replace(`:${k}`, encodeURIComponent(v));
  });
  return p;
}

function matchPattern(pattern, pathname) {
  const pp = pattern.split("/").filter(Boolean);
  const pa = pathname.split("/").filter(Boolean);
  if (pp.length !== pa.length) return null;
  const params = {};
  for (let i = 0; i < pp.length; i++) {
    if (pp[i].startsWith(":")) params[pp[i].slice(1)] = decodeURIComponent(pa[i]);
    else if (pp[i] !== pa[i]) return null;
  }
  return params;
}

export function resolveRoute(pathname) {
  const clean = pathname.replace(/\/+$/, "") || "/";
  for (const key of Object.keys(ROUTES)) {
    for (const lang of LANGS) {
      const params = matchPattern(ROUTES[key][lang], clean);
      if (params) return { key, lang, params };
    }
  }
  return null;
}

export function alternatePath(pathname, targetLang) {
  const r = resolveRoute(pathname);
  if (!r) return targetLang === "es" ? "/" : `/${targetLang}`;
  return buildPath(r.key, targetLang, r.params);
}
